import * as THREE from 'three';

import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';

import { RoomEnvironment } from 'three/addons/environments/RoomEnvironment.js';



// One lamp and one WebGL context travel continuously between the existing panels.

const copy=JSON.parse(document.querySelector('#LumaConfig')?.textContent||'{}');

const reduced=matchMedia('(prefers-reduced-motion: reduce)');

const clamp=THREE.MathUtils.clamp,lerp=THREE.MathUtils.lerp,smooth=THREE.MathUtils.smoothstep,TAU=Math.PI*2;

const motion=()=>!reduced.matches&&document.body.dataset.motion!=='false';

let cleanup;

function start(){

  cleanup?.();

  const els=[...document.querySelectorAll('[data-lamp-stage]')];if(!els.length){document.dispatchEvent(new Event('luma:world-ready'));return;}

  const life=new AbortController(),on={signal:life.signal};

  const stages=els.map(el=>({el,kind:el.dataset.lampStage,glow:null,ash:false,room:'hallway',explore:false,orbit:{x:0,y:0}}));

  const world=document.createElement('div');world.className='luma-world';world.setAttribute('aria-hidden','true');document.body.append(world);

  let renderer,model,lamp,mount,environment,frame=0,last=0,disposed=false,loaded=false,dragging=null,state=null,transfer=null,lastFinish='',needsResize=true;

  const scene=new THREE.Scene(),rig=new THREE.Group();scene.add(rig);

  const camera=new THREE.OrthographicCamera(-innerWidth/2,innerWidth/2,innerHeight/2,-innerHeight/2,.1,6000);camera.position.z=3000;

  const woods=[],diffusers=[],meshes=[],bounds=new THREE.Box3(),partBounds=new THREE.Box3(),center=new THREE.Vector3();

  let walnutMap,ashMap,grainBump,glowSprite,chargeIndicator,usbSocket,sensorLens,modeSwitch,diffuserMesh;const waves=[];

  const svgNS='http://www.w3.org/2000/svg',pointer=document.createElementNS(svgNS,'svg');pointer.classList.add('luma-feature-pointer');pointer.setAttribute('aria-hidden','true');pointer.innerHTML='<defs><marker id="luma-feature-arrow" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><path d="M1 1 L6 4 L1 7" fill="none" stroke="currentColor" stroke-width="1.3"/></marker></defs><path class="feature-leader" fill="none" stroke="currentColor" stroke-width="1.4" marker-end="url(#luma-feature-arrow)"/><circle r="4.5" fill="none" stroke="currentColor" stroke-width="1.2"/>';

  const leader=pointer.querySelector('.feature-leader'),pointerDot=pointer.querySelector('circle'),featurePoint=new THREE.Vector3();

  const fail=err=>{if(disposed)return;world.hidden=true;document.body.classList.remove('world-ready');stages.forEach(s=>s.el.classList.remove('is-ready'));document.dispatchEvent(new Event('luma:world-ready'));console.warn('LUMA 3D image fallback:',err?.message||'WebGL unavailable');};

  try{

    renderer=new THREE.WebGLRenderer({alpha:true,antialias:true,powerPreference:'high-performance'});

    renderer.setClearColor(0x000000,0);renderer.outputColorSpace=THREE.SRGBColorSpace;renderer.toneMapping=THREE.ACESFilmicToneMapping;renderer.toneMappingExposure=1.05;world.append(renderer.domElement,pointer);

    const room=new RoomEnvironment(),pmrem=new THREE.PMREMGenerator(renderer);environment=pmrem.fromScene(room,.035);scene.environment=environment.texture;room.dispose();pmrem.dispose();

  }catch(err){fail(err);world.remove();return;}

  scene.add(new THREE.HemisphereLight(0xfff6e6,0x283535,1.2));

  const key=new THREE.DirectionalLight(0xfff7e9,2.6);key.position.set(-500,700,1600);scene.add(key);

  const rim=new THREE.DirectionalLight(0xd6e4f4,1.6);rim.position.set(900,300,-900);scene.add(rim);

  const fill=new THREE.DirectionalLight(0xffffff,.65);fill.position.set(600,-500,800);scene.add(fill);

  function radialTexture(){

    const c=document.createElement('canvas');c.width=c.height=256;const ctx=c.getContext('2d'),g=ctx.createRadialGradient(128,128,0,128,128,128);

    g.addColorStop(0,'rgba(255,225,167,.55)');g.addColorStop(.18,'rgba(255,189,83,.22)');g.addColorStop(.52,'rgba(226,144,40,.05)');g.addColorStop(1,'rgba(220,140,35,0)');ctx.fillStyle=g;ctx.fillRect(0,0,256,256);

    const tex=new THREE.CanvasTexture(c);tex.colorSpace=THREE.SRGBColorSpace;return tex;

  }

  function poreTexture(){

    // Technical micro-height detail, independent of the photographic colour map.

    const c=document.createElement('canvas');c.width=c.height=256;const ctx=c.getContext('2d'),pixels=ctx.createImageData(256,256);let seed=7247;

    for(let y=0;y<256;y++)for(let x=0;x<256;x++){seed=(seed*1664525+1013904223)>>>0;const v=128+Math.sin(x*.61+Math.sin(y*.014)*2)*17+((seed/4294967296)-.5)*22;const i=(y*256+x)*4;pixels.data[i]=pixels.data[i+1]=pixels.data[i+2]=v;pixels.data[i+3]=255;}

    ctx.putImageData(pixels,0,0);const tex=new THREE.CanvasTexture(c);tex.wrapS=tex.wrapT=THREE.RepeatWrapping;return tex;

  }

  function schedule(){if(!frame&&!disposed&&!document.hidden)frame=requestAnimationFrame(draw);}

  function resize(){

    if(disposed)return;camera.left=-innerWidth/2;camera.right=innerWidth/2;camera.top=innerHeight/2;camera.bottom=-innerHeight/2;camera.updateProjectionMatrix();

    renderer.setPixelRatio(Math.min(devicePixelRatio,innerWidth<=750?1.5:1.8));renderer.setSize(innerWidth,innerHeight);stages.forEach(s=>s.home=null);transfer=null;needsResize=false;

  }

  function progress(s){const host=s.el.closest('[data-scroll-scene]');if(!host)return 0;const pin=host.querySelector('.hero,.opening-sticky,.story-grid,.process-layout,.spaces');if(!pin)return 0;const r=host.getBoundingClientRect(),offset=parseFloat(getComputedStyle(pin).top)||0;return clamp((offset-r.top)/Math.max(1,r.height-pin.clientHeight),0,1);}

  function rect(s){const r=s.el.getBoundingClientRect(),mobile=innerWidth<=750;const top=mobile?32:36,bottom=s.kind==='opening'?(mobile?72:104):s.kind==='spaces'?(mobile?52:60):(mobile?48:64);return{x:r.left+12,y:r.top+top,w:Math.max(30,r.width-24),h:Math.max(70,r.height-top-bottom),raw:r};}

  function unwrap(value,near){return value+Math.round((near-value)/TAU)*TAU;}

  function storyPhase(s){

    const section=s.el.closest('.story,.process'),chapters=[...section.querySelectorAll('.chapter,.process-step')];

    if(innerWidth<=750){const r=section.getBoundingClientRect(),pin=section.querySelector('.story-grid,.process-layout');const offset=parseFloat(getComputedStyle(pin).top)||0;return clamp((offset-r.top)/Math.max(1,r.height-pin.clientHeight),0,1)*(chapters.length-1);}

    const positions=chapters.map(c=>{const r=c.getBoundingClientRect();return r.top+Math.min(r.height*.4,135);}),line=innerHeight*.50;let phase=0;

    for(let i=0;i<positions.length-1;i++)if(line>=positions[i])phase=i+clamp((line-positions[i])/Math.max(1,positions[i+1]-positions[i]),0,1);return phase;

  }

  function pose(s){

    const p=motion()?progress(s):0;let o={rx:.13,ry:-.48,rz:-.22,lift:0,base:0,glow:1,ash:s.ash?1:0,sensor:0,charge:0,scale:1};

    if(s.kind==='hero'){o.rx=.10;o.ry=-.35+.18*smooth(p,.15,.75);o.rz=-.10;o.glow=smooth(p,.015,.15);}

    else if(s.kind==='opening'){o.rx=.10;o.ry=-.17+.90*smooth(p,.12,.80);o.rz=-.10;o.lift=smooth(p,.12,.5);o.base=.30*smooth(p,.2,.55);o.glow=1-smooth(p,.05,.18)+smooth(p,.36,.53);}

    else if(s.kind==='story'||s.kind==='process'){

      const phase=motion()?storyPhase(s):0;

      let keys=[{rx:.10,ry:-.35,rz:-.10,lift:1,base:.30,glow:1,sensor:0,charge:0,ash:0},{rx:0,ry:0,rz:0,lift:0,base:0,glow:1,sensor:1,charge:0,ash:0},{rx:-Math.PI/2-.10,ry:0,rz:.30,lift:.3,base:.35,glow:0,sensor:0,charge:1,ash:0},{rx:.10,ry:-.28,rz:-.10,lift:0,base:0,glow:1,sensor:0,charge:0,ash:1}];

      if(s.kind==='process')keys=[{rx:.12,ry:-.35,rz:-.10,lift:1,base:.35,glow:0,sensor:0,charge:0,ash:1},{rx:-Math.PI/2-.15,ry:0,rz:.25,lift:.25,base:.25,glow:0,sensor:0,charge:1,ash:1},{rx:.10,ry:-.28,rz:-.12,lift:.65,base:.20,glow:1,sensor:0,charge:0,ash:1}];

      const a=Math.min(keys.length-2,Math.floor(phase)),t=smooth(phase-a,.45,.85),active=a+(t>.5?1:0);Object.keys(keys[0]).forEach(k=>o[k]=lerp(keys[a][k],keys[a+1][k],t));

      const chapters=[...s.el.closest('.story,.process').querySelectorAll('.chapter,.process-step')];chapters.forEach((c,i)=>c.classList.toggle('is-current',active===i));s.feature=chapters[active]?.querySelector('.micro')?.textContent;s.chapter=chapters[active];s.active=active;s.el.closest('.story,.process').dataset.active=active;

      if(s.kind==='story'&&phase>.70&&phase<1.15)o.glow=smooth(phase,.76,1.06);o.scale=lerp(1,1.08,o.charge);

    }else if(s.kind==='spaces'){o.rx=.08;o.ry=-.2;o.rz=s.room==='bedside'?Math.PI:s.room==='shelf'?-Math.PI/2:0;o.glow=1;o.ash=1;}

    if(!motion()){o.rx=.10;o.ry=-.35;o.rz=s.kind==='spaces'?(s.room==='bedside'?Math.PI:s.room==='shelf'?-Math.PI/2:0):-.10;o.lift=0;o.glow=1;o.sensor=o.charge=0;o.ash=['spaces','process'].includes(s.kind)?1:s.ash?1:0;}
    if(s.glow!==null)o.glow=s.glow?1:0;if(s.explore){o.rx+=s.orbit.x;o.ry+=s.orbit.y;}return o;

  }

  function target(){

    let from=stages[0],to=from,t=1;

    for(let i=1;i<stages.length;i++){const next=rect(stages[i]);if(next.y<innerHeight*.94){from=stages[i-1];to=stages[i];t=smooth((innerHeight*.94-next.y)/(innerHeight*.54),0,1);}else break;}

    const a=rect(from),b=rect(to),pa=pose(from),pb=pose(to),flight=from!==to&&t<1;let o={};

    for(const k of Object.keys(pa))o[k]=lerp(pa[k],['rx','ry','rz'].includes(k)?unwrap(pb[k],pa[k]):pb[k],t);

    if(flight){

      if(transfer?.from!==from||transfer?.to!==to){const source=state?.alpha>.01?state:pa;transfer={from,to,rx:source.rx,ry:source.ry,rz:source.rz,lift:source.lift,base:source.base};}

      for(const k of ['rx','ry','rz','lift','base'])o[k]=transfer[k];

    }else transfer=null;

    const cx=lerp(a.x+a.w/2,b.x+b.w/2,t),cy=lerp(a.y+a.h/2,b.y+b.h/2,t),w=lerp(a.w,b.w,t),h=lerp(a.h,b.h,t);

    const first=stages[0],lastStage=stages[stages.length-1],lastSection=lastStage.el.closest('section').getBoundingClientRect();
    const entry=first.kind==='hero'?1:smooth((innerHeight*.92-first.el.getBoundingClientRect().top)/(innerHeight*.18),0,1);
    const exit=smooth((lastSection.bottom-innerHeight*.78)/(innerHeight*.18),0,1),alpha=entry*exit;
    return{...o,cx,cy,w,h,alpha,stage:t>.5?to:from,flight};

  }

  function finish(ash){const k=ash>.5?'ash':'walnut';if(k===lastFinish)return;lastFinish=k;woods.forEach(m=>{m.map=k==='ash'?ashMap:walnutMap;m.color.setHex(k==='ash'?0xd4b78e:0xffffff);m.needsUpdate=true;});}
  function apply(o,now){

    finish(o.ash);rig.position.set(0,0,0);rig.scale.setScalar(1);rig.rotation.set(o.rx,o.ry,o.rz);lamp.position.set(o.lift*.047,o.lift*.012,o.lift*.042);mount.position.set(-o.lift*.015,-.043,-.018);mount.rotation.set(0,o.base,0);

    rig.updateMatrixWorld(true);bounds.makeEmpty();for(const mesh of meshes)bounds.union(partBounds.copy(mesh.geometry.boundingBox).applyMatrix4(mesh.matrixWorld));bounds.getCenter(center);const span=bounds.getSize(new THREE.Vector3()),mobile=innerWidth<=750,opening=mobile&&o.stage?.kind==='opening',visibleHeight=innerHeight-(mobile?110:112),size=Math.min(o.w*(opening?.90:.82)/Math.max(.01,span.x),o.h*(opening?.92:.87)/Math.max(.01,span.y), (innerWidth-32)/Math.max(.01,span.x),visibleHeight/Math.max(.01,span.y))/Math.max(1,o.scale/1.08);rig.scale.setScalar(size);
    const halfW=span.x*size/2+8,halfH=span.y*size/2+8,top=mobile?8:96,bottom=innerHeight-(mobile?100:8);

    const cx=clamp(o.cx,halfW,innerWidth-halfW),cy=clamp(o.cy,top+halfH,bottom-halfH);

    rig.position.set(cx-innerWidth/2-center.x*size,innerHeight/2-cy-center.y*size,0);

    world.dataset.bounds=[cx-halfW,cy-halfH,cx+halfW,cy+halfH].map(v=>v.toFixed(1)).join(',');

    const glow=clamp(o.glow,0,1);diffusers.forEach(m=>{m.emissive.setRGB(1,.67,.30);m.emissiveIntensity=glow*2.3;});glowSprite.material.opacity=glow*.76;glowSprite.position.set(lamp.position.x,lamp.position.y+.0475,lamp.position.z-.014);glowSprite.scale.set(.175,.22,1);
    chargeIndicator.material.emissive.setRGB(.12,.35,1);chargeIndicator.material.emissiveIntensity=o.charge*2.2;

    waves.forEach((wave,i)=>{const phase=(now*.00036+i/3)%1;wave.visible=motion()&&o.sensor>.06;wave.scale.setScalar(.6+phase*2.8);wave.material.opacity=(1-phase)*o.sensor*.65;});renderer.render(scene,camera);

    const storyFeature=[mount,sensorLens,usbSocket,null],processFeature=[mount,modeSwitch,diffuserMesh],feature=o.stage?.kind==='story'?storyFeature[o.stage.active??0]:o.stage?.kind==='process'?processFeature[o.stage.active??0]:null;

    if(['story','process'].includes(o.stage?.kind)&&feature&&!o.flight&&motion()){

      rig.updateMatrixWorld(true);if(feature===mount)feature.getWorldPosition(featurePoint);else{feature.geometry.boundingBox.getCenter(featurePoint);feature.localToWorld(featurePoint);}featurePoint.project(camera);

      const headingNode=o.stage.chapter?.querySelector('h3');let heading;
      if(headingNode){const textRange=document.createRange();textRange.selectNodeContents(headingNode);heading=textRange.getBoundingClientRect();}
      const px=(featurePoint.x+1)*innerWidth/2,py=(1-featurePoint.y)*innerHeight/2,r=o.stage.el.getBoundingClientRect();
      const textOnLeft=heading&&heading.right<r.right,origin=heading?(textOnLeft?heading.right+10:heading.left-10):r.left-16,leadY=heading?clamp(heading.top+heading.height*.5,105,innerHeight-120):py-32,elbow=textOnLeft?px-25:px+25;

      leader.setAttribute('d',`M ${origin} ${leadY} L ${elbow} ${leadY} L ${px+(textOnLeft?-5:5)} ${py-3}`);pointerDot.setAttribute('cx',px);pointerDot.setAttribute('cy',py);pointer.style.opacity='1';pointer.dataset.feature=feature===usbSocket?'usb':feature===sensorLens?'sensor':feature===modeSwitch?'switch':feature===diffuserMesh?'diffuser':'mount';

    }else{pointer.style.opacity='0';pointer.dataset.feature='';}

    if(o.stage){o.stage.el.style.setProperty('--glow',glow);o.stage.el.querySelector('.scene-corner').textContent=(['story','process'].includes(o.stage.kind)&&o.stage.feature?o.stage.feature:(o.ash>.5?copy.ashFinish:copy.walnutFinish))+'\n'+copy.warmLight;const button=o.stage.el.parentElement.querySelector('[data-glow-toggle]');if(button){button.setAttribute('aria-pressed',String(glow>.5));button.querySelector('span').textContent=glow>.5?copy.glowOn:copy.glowOff;}}

  }

  function draw(now){
    frame=0;if(disposed||!loaded||document.hidden)return;if(needsResize)resize();const dt=Math.min(.05,(now-last)/1000||.016);last=now;

    if(!motion()){world.hidden=false;pointer.style.opacity='0';renderer.autoClear=false;renderer.clear();for(const s of stages){const r=rect(s);if(r.raw.bottom<0||r.raw.top>innerHeight)continue;apply({...pose(s),cx:r.x+r.w/2,cy:r.y+r.h/2,w:r.w,h:r.h,stage:s},now);}renderer.autoClear=true;world.style.opacity='1';return;}
    const next=target();if(!state)state={...next};const ease=1-Math.exp(-dt*15);let unsettled=false;

    for(const k of ['rx','ry','rz','lift','base','glow','ash','sensor','charge','scale','cx','cy','w','h','alpha']){const v=['rx','ry','rz'].includes(k)?unwrap(next[k],state[k]):next[k];state[k]=lerp(state[k],v,ease);if(Math.abs(state[k]-v)>.001)unsettled=true;}

    if(next.alpha===0)state.alpha=0;world.hidden=next.alpha===0;
    state.stage=next.stage;state.flight=next.flight;world.dataset.scene=next.stage.kind;world.dataset.flight=String(next.flight);world.dataset.light=state.glow>.5?'on':'off';world.dataset.rotation=[state.rx,state.ry,state.rz].map(v=>v.toFixed(4)).join(',');world.style.opacity=String(state.alpha);if(state.alpha>.005)apply(state,now);if(unsettled||state.sensor>.05)schedule();
  }

  async function load(){

    try{

      const gltf=await new GLTFLoader().loadAsync(els[0].dataset.modelUrl);if(disposed)return;model=gltf.scene;rig.add(model);grainBump=poreTexture();

      model.traverse(o=>{const name=o.name.replaceAll('_',' ');if(name==='Portable lamp')lamp=o;if(name==='Magnetic wall mount')mount=o;if(!o.isMesh)return;meshes.push(o);o.geometry.computeBoundingBox();

        if(/wood-grain|collar seam/i.test(name)){const previous=o.material,m=new THREE.MeshPhysicalMaterial({map:previous.map,color:0xffffff,roughness:.44,metalness:0,clearcoat:.18,clearcoatRoughness:.36,bumpMap:grainBump,bumpScale:.000045,envMapIntensity:.7});o.material=m;woods.push(m);previous.dispose();if(m.map){m.map.anisotropy=Math.min(8,renderer.capabilities.getMaxAnisotropy());walnutMap=m.map;}}

        else if(/diffuser/i.test(name)){o.material=new THREE.MeshPhysicalMaterial({color:0xf0eee7,roughness:.36,metalness:0,clearcoat:.25,clearcoatRoughness:.5,emissive:0xffd397,emissiveIntensity:0,envMapIntensity:.9});diffusers.push(o.material);diffuserMesh=o;}

        else{o.material=o.material.clone();o.material.envMapIntensity=.8;if(/PIR sensor lens/.test(name)){o.material.roughness=.08;o.material.metalness=.12;sensorLens=o;}if(/Tiny status indicator/.test(name))chargeIndicator=o;if(/Micro-USB dark socket/.test(name))usbSocket=o;if(/AUTO OFF ON sliding switch/.test(name))modeSwitch=o;}

      });

      if(!lamp||!mount||!woods.length||!chargeIndicator)throw Error('Lamp articulation missing');const baseCenter=new THREE.Vector3(0,-.043,-.018);mount.children.forEach(o=>o.position.sub(baseCenter));mount.position.copy(baseCenter);

      ashMap=await new THREE.TextureLoader().loadAsync(els[0].dataset.ashUrl);ashMap.colorSpace=THREE.SRGBColorSpace;ashMap.flipY=false;ashMap.wrapS=ashMap.wrapT=THREE.RepeatWrapping;ashMap.anisotropy=Math.min(8,renderer.capabilities.getMaxAnisotropy());

      glowSprite=new THREE.Sprite(new THREE.SpriteMaterial({map:radialTexture(),transparent:true,depthWrite:false,blending:THREE.AdditiveBlending,opacity:0}));rig.add(glowSprite);

      for(let i=0;i<3;i++){const wave=new THREE.Mesh(new THREE.TorusGeometry(.01,.00020,4,80),new THREE.MeshBasicMaterial({color:0xe4bd76,transparent:true,opacity:0,depthWrite:false}));wave.position.set(0,-.062,.030);lamp.add(wave);waves.push(wave);}

      loaded=true;document.body.classList.add('world-ready');stages.forEach(s=>s.el.classList.add('is-ready'));document.dispatchEvent(new Event('luma:world-ready'));resize();schedule();

    }catch(err){fail(err);}

  }

  document.addEventListener('click',e=>{

    const button=e.target.closest('[data-glow-toggle]');if(button){const el=button.parentElement.querySelector('[data-lamp-stage]'),s=stages.find(x=>x.el===el);if(s){s.glow=button.getAttribute('aria-pressed')!=='true';schedule();}}

    const explore=e.target.closest('[data-explore]');if(explore){const s=stages.find(x=>x.el===explore.closest('.opening-visual').querySelector('[data-lamp-stage]'));if(s){s.explore=!s.explore;if(!s.explore)s.orbit={x:0,y:0};s.el.style.touchAction=s.explore?'none':'pan-y';explore.setAttribute('aria-pressed',String(s.explore));explore.textContent=s.explore?copy.followScroll:copy.explore;schedule();}}

    const finishButton=e.target.closest('[data-finish-toggle]');if(finishButton){const s=stages.find(x=>x.el===finishButton.closest('.opening-visual').querySelector('[data-lamp-stage]'));if(s){s.ash=!s.ash;finishButton.setAttribute('aria-pressed',String(s.ash));finishButton.textContent=s.ash?copy.walnutFinish:copy.ashFinish;schedule();}}

  },on);

  stages.forEach(s=>{

    s.el.addEventListener('pointerdown',e=>{if(!s.explore)return;dragging={s,x:e.clientX,y:e.clientY};s.el.setPointerCapture(e.pointerId);},on);

    s.el.addEventListener('pointermove',e=>{if(dragging?.s!==s)return;s.orbit.y+=(e.clientX-dragging.x)*.009;s.orbit.x=clamp(s.orbit.x+(e.clientY-dragging.y)*.007,-Math.PI,Math.PI);dragging.x=e.clientX;dragging.y=e.clientY;schedule();},on);

    ['pointerup','pointercancel','lostpointercapture'].forEach(event=>s.el.addEventListener(event,()=>dragging=null,on));

  });

  document.addEventListener('luma:space',e=>{const s=stages.find(x=>x.el===e.detail.stage);if(s){s.room=e.detail.key;schedule();}},on);document.addEventListener('luma:scroll',schedule,on);window.addEventListener('scroll',schedule,{...on,passive:true});window.addEventListener('resize',()=>{needsResize=true;schedule();},{...on,passive:true});

  document.addEventListener('visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(frame);frame=0;}else schedule();},on);reduced.addEventListener('change',()=>{state=null;schedule();},on);renderer.domElement.addEventListener('webglcontextlost',e=>{e.preventDefault();fail(Error('Graphics context lost'));},on);

  const resizeObserver=new ResizeObserver(schedule);resizeObserver.observe(document.querySelector('main'));

  cleanup=()=>{disposed=true;life.abort();resizeObserver.disconnect();cancelAnimationFrame(frame);renderer.dispose();environment?.dispose();ashMap?.dispose();walnutMap?.dispose();grainBump?.dispose();glowSprite?.material.map?.dispose();scene.traverse(o=>{o.geometry?.dispose();o.material?.dispose?.();});world.remove();document.body.classList.remove('world-ready');stages.forEach(s=>s.el.classList.remove('is-ready'));};

  window.addEventListener('pagehide',e=>{if(e.persisted){cancelAnimationFrame(frame);frame=0;}else cleanup?.();},on);window.addEventListener('pageshow',schedule,on);load();

}

start();

document.addEventListener('shopify:section:load',e=>{if(e.target.querySelector('[data-lamp-stage]'))start();});

document.addEventListener('shopify:section:unload',e=>{if(e.target.querySelector('[data-lamp-stage]'))cleanup?.();});

